import React, { useEffect, useState } from "react";
import { Container, Table, Button, Modal, Badge, Row, Col, Card, InputGroup, FormControl } from "react-bootstrap";
import { TbSearch } from "react-icons/tb";
import { UserUnknownTreeApproveApi, virtualMallUserTreeApi } from "./VirtualMallApi/api";
import "./VirtualMallUnknownUsers.scss";

const UnknownUser = () => {

    const [data, setData] = useState([]);
    const [approveModal, setApproveModal] = useState(false);
    const [search, setSearch] = useState("");

    const matchesSearch = (value) =>
        String(value ?? "").toLowerCase().includes(search.toLowerCase());

    const filteredData = data.filter(item =>
        matchesSearch(item.vu_referal_id) ||
        matchesSearch(item.vu_sponsor_id) ||
        matchesSearch(item.vu_master_id) ||
        matchesSearch(item.vu_mobile) ||
        matchesSearch(item.vu_auto_password) ||
        matchesSearch(item.vu_status) ||
        matchesSearch(new Date(item.created_at).toLocaleString())
    );

    const handleSearch = () => {
        getUnknownUserList();
    };

    const [selectedItem, setSelectedItem] = useState(null);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getUnknownUserList();
    }, []);

    const getUnknownUserList = async () => {
        setLoading(true);
        try {
            const response = await virtualMallUserTreeApi({ dummy_user: "true" });
            console.log("Unknown user list response:", response.data);
            setData(response.data);
        } catch (error) {
            console.error("Error fetching unknown user list:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleApprove = async () => {
        if (!selectedItem) return;
        try {
            const response = await UserUnknownTreeApproveApi({ vu_id: selectedItem.vu_id, vu_real_user: 1, vu_status: "active" });
            console.log("User tree approve response:", response.data);
            getUnknownUserList();
            setApproveModal(false);
            setSelectedItem(null);
        } catch (error) {
            console.error("Error fetching User tree approve:", error);
        }
    };

    return (
        <Container fluid className="p-4 unknown-users-wrapper">
            <Row className="mb-4 align-items-center justify-content-between page-header">
                <Col>
                    <h3 className="mb-0">Unknown Users Log</h3>
                    <p className="mb-0">Monitor and manage unidentified access attempts</p>
                </Col>
            </Row>

            <Card className="">
                <div className="toolbar">
                    <InputGroup className="w-auto search-input-group" style={{ maxWidth: "300px" }}>
                        <InputGroup.Text>
                            <TbSearch size={18} />
                        </InputGroup.Text>
                        <FormControl
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search by ID, Phone..."
                            className="shadow-none"
                        />
                    </InputGroup>
                </div>

                <div className="table-responsive">
                    <Table hover className="align-middle">
                        <thead>
                            <tr>
                                <th className="ps-4">ID</th>
                                <th>Referral ID</th>
                                <th>Phone Number</th>
                                <th>Sponsor ID</th>
                                <th>Master ID</th>
                                <th>Password</th>
                                <th>Status</th>
                                <th>Created At</th>
                                <th className="pe-4 text-end">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="9" className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : filteredData.length > 0 ? (
                                filteredData.map((item, index) => (
                                    <tr key={item.vu_id}>
                                        <td className="ps-4">
                                            <span className="id-cell">#{item.vu_id}</span>
                                        </td>
                                        <td>
                                            <span className="user-info">{item.vu_referal_id}</span>
                                        </td>
                                        <td className="meta-info">{item.vu_mobile || "N/A"}</td>
                                        <td className="meta-info">{item.vu_sponsor_id}</td>
                                        <td className="meta-info">{item.vu_master_id}</td>
                                        <td>
                                            <span className="password-badge">{item.vu_auto_password}</span>
                                        </td>
                                        <td>
                                            <span className={`status-badge status-${item.vu_status === "active" ? "active" : "pending"}`}>
                                                {item.vu_status}
                                            </span>
                                        </td>
                                        <td className="meta-info">{new Date(item.created_at).toLocaleString()}</td>
                                        <td className="text-end pe-4">
                                            <Button
                                                onClick={() => { setSelectedItem(item); setApproveModal(true); }}
                                                className="btn-approve"
                                                size="sm"
                                            >
                                                Approve
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="empty-state">
                                        <TbSearch size={48} />
                                        <p>No Unknown Users Found</p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                <div className="card-footer bg-white border-top py-3">
                    <small className="text-muted">Showing {filteredData.length} records</small>
                </div>
            </Card>

            <Modal show={approveModal} onHide={() => setApproveModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Approval</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-0">Are you sure you want to approve user <strong>{selectedItem?.vu_referal_id}</strong>? This will convert the account into a real user account.</p>
                </Modal.Body>
                <Modal.Footer className="">
                    <Button variant="link" className="text-muted text-decoration-none me-2" onClick={() => setApproveModal(false)}>
                        Cancel
                    </Button>
                    <Button
                        className="btn-approve px-4"
                        onClick={handleApprove}
                        style={{ minWidth: '120px' }}
                    >
                        Approve User
                    </Button>
                </Modal.Footer>
            </Modal>



        </Container>
    );
};

export default UnknownUser;
